import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-5xl font-bold text-primary mb-4">404</h1>
            <p className="text-lg text-gray-600 mb-6">
                Page not available
            </p>

            <Link
                to="/"
                className="px-6 py-2 rounded-lg bg-primary text-white hover:opacity-90 transition"
            >
                Go Home
            </Link>
        </div>
    );
};

export default NotFound;
